module.exports = __webpack_public_path__ + "img/fifa_win.f976206f.png";